<template>
  <div class="search">
    <b-row style="margin: auto">
      <b-col cols="3">    
        <TMLinks />
      </b-col>
      <b-col cols="9" class="mt-1">    
        <Search />
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Search from '@/components/Search.vue'
import TMLinks from '@/components/TMLinks.vue'

export default {
  name: 'TmlSearch',
  components: {
    Search,
    TMLinks
  }
}
</script>
